import React from "react"; // I think this should be deprecated in favor of ScrollToTop. This only does it
// on mount, whereas ScrollToTop does it whenever the react router location
// changes.

export default class ScrollToTopOnMount extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return null;
  }
}
